<template>
	<div class="white-button" :class="[buttonClass, widthClass]">
		<b-button
			:disabled="disabled"
			@click.stop="$emit('clicked')"
			class="rounded-pill"
		>
			{{ text }}
		</b-button>
	</div>
</template>

<script>
export default {
  name: "OutlineButton",

	props: {
		text: {
			type: String,
			default: "",
		},
		type: {
			type: String,
			default: "",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		widthClass: {
			type: String,
			default: "button-fit-content",
		},
		redButton:{
			type:Boolean,
			default:false,
		}
	},
  computed:{     buttonClass(){
        return this.redButton ? 'red-whitebutton' : 'blue-whitebutton';
      }
    },
};
</script>

<style>
.white-button .btn-secondary {
  background-color: var(--color-white);
  padding: 0.25rem 1.125rem;
  font-family: "Montserrat", sans-serif;
  font-size: var(--size-13);
  font-weight: var(--weight-600);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3125rem;
  width: 100%;
}

.blue-whitebutton .btn-secondary {
  border: 1px solid var(--primary-blue);
  color: var(--primary-blue);
}

.red-whitebutton .btn-secondary {
  border: 1px solid var(--validation-color);
  color: var(--validation-color);
}


.white-button .btn-secondary:hover {
  box-shadow: 0px 0px 0px 0px rgba(32, 99, 155, 0.2),
    2px 3px 7px 0px rgba(32, 99, 155, 0.2),
    7px 10px 12px 0px rgba(32, 99, 155, 0.17),
    44px 63px 22px 0px rgba(32, 99, 155, 0);
    background-color: var(--color-white) !important;
}

.blue-whitebutton .btn-secondary:hover {
    color:  var(--primary-blue);
    border: 1px solid var(--primary-blue);
}

.red-whitebutton .btn-secondary:hover {
  color:  var(--validation-color);
  border: 1px solid var(--validation-color);
}

.white-button .btn-secondary:focus {
  box-shadow: none;
}

.blue-whitebutton .btn-secondary:focus {
  border: 1px solid var(--primary-blue);
  color: var(--primary-blue);
}

.red-whitebutton .btn-secondary:focus {
  border: 1px solid var(--validation-color);
  color: var(--validation-color);
}

.white-button .btn-secondary:disabled {
  cursor: not-allowed;
  background-color: var(--color-white);
  opacity: 0.5;
  box-shadow: none;
}

.red-whitebutton .btn-secondary:disabled {
  border-color: var(--validation-color);
  color: var(--validation-color);
}

.blue-whitebutton .btn-secondary:disabled {
  border-color: var(--primary-blue);
  color: var(--primary-blue);
}

.white-button .btn-secondary:not(:disabled):not(.disabled):active,
.white-button .btn-secondary:not(:disabled):not(.disabled).active,
.white-button .show > .btn-secondary.dropdown-toggle {
  background-color: var(--color-white);
  box-shadow: none;
}

.blue-whitebutton .btn-secondary:not(:disabled):not(.disabled):active,
.blue-whitebutton .btn-secondary:not(:disabled):not(.disabled).active,
.blue-whitebutton .show > .btn-secondary.dropdown-toggle {
  border-color: var(--primary-blue);
  color: var(--primary-blue);
}

.red-whitebutton .btn-secondary:not(:disabled):not(.disabled):active,
.red-whitebutton .btn-secondary:not(:disabled):not(.disabled).active,
.red-whitebutton .show > .btn-secondary.dropdown-toggle {
  border-color: var(--validation-color);
  color: var(--validation-color);
}

.button-width {
  width: 5.625rem;
}

.button-fit-content {
  width: fit-content;
}

.blue-whitebutton .btn-outline-secondary:not(:disabled):not(.disabled):active,
.blue-whitebutton .btn-outline-secondary:not(:disabled):not(.disabled).active,
.blue-whitebutton .show > .btn-outline-secondary.dropdown-toggle {
  color: var(--primary-blue);
  border-color: var(--primary-blue);
}

.red-whitebutton .btn-outline-secondary:not(:disabled):not(.disabled):active,
.red-whitebutton .btn-outline-secondary:not(:disabled):not(.disabled).active,
.red-whitebutton .show > .btn-outline-secondary.dropdown-toggle {
  color: var(--validation-color);
  border-color: var(--validation-color);
}

.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .btn-outline-secondary.dropdown-toggle {
  background-color: var(--color-white);
}
.btn-outline-secondary:focus,
.btn-outline-secondary.focus {
  box-shadow: unset;
}

/*button width 200px */

.w-200px {
  width: 200px;
}

.filterbtn button {
  border: 1px solid #20639b;
  color: #20639b;
  font-size: 11px;
  width: 70px;
  height: 23px;
}
</style>
